<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.exsbitems.list.name') }}:</label>
            <input v-model.lazy="filters.name" v-debounce="delay" class="form-control" type="text" placeholder="">
          </div>
        </b-col>
        <b-col>
          <div class="form-group">
            <label>{{ $t('views.exsbitems.list.category') }}</label>
            <fg-input>
              <el-select
                :placeholder="$t('views.exsbitems.form.category')"
                filterable
                class="select-default"
                v-model="filters.category">
                <el-option v-for="option in categories"
                           class="select-default"
                           :value="option['@id']"
                           :label="option.name"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
        <b-col>
          <div class="form-group">
            <label
              class="form-control-label">{{$t('views.exsbitems.form.measure')}}:</label>
            <fg-input>
              <el-select
                class="select-default"
                :placeholder="$t('views.exsbitems.form.measure')"
                filterable
                v-model="filters.measure">
                <el-option v-for="option in measures"
                           class="select-default"
                           :value="option['@id']"
                           :label="option.name"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
        <b-col>
          <div class="form-group">
            <label
              class="form-control-label">{{$t('views.exsbitems.form.vatRate')}}:</label>
            <fg-input>
              <el-select
                class="select-default"
                :placeholder="$t('views.exsbitems.form.vatRate')"
                filterable
                v-model="filters.vatRate">
                <el-option v-for="option in vatRates"
                           class="select-default"
                           :value="option['@id']"
                           :label="option.range"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
        <b-col v-if="itemTagOptions.length > 0">
          <b-form-group>
            <label>{{$t("views.exsbitems.form.tags")}}: </label>
            <multi-select :options="itemTagOptions" :selected-options="tagsFilter" @select="onSelectTags" >
            </multi-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="form-group">
            <label
              class="form-control-label">{{$t('views.exsbitems.form.brand')}}:</label>
            <fg-input>
              <el-select
                class="select-default"
                :placeholder="$t('views.exsbitems.form.brand')"
                filterable
                v-model="filters.brand">
                <el-option v-for="option in itemBrands"
                           class="select-default"
                           :value="option['@id']"
                           :label="option.brandTitle"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
        <b-col>
          <div class="form-group">
            <label
              class="form-control-label">{{$t('views.exsbitems.form.itemType')}}:</label>
            <fg-input>
              <el-select
                class="select-default"
                :placeholder="$t('views.exsbitems.form.itemType')"
                filterable
                v-model="filters.itemType">
                <el-option v-for="option in itemTypes"
                           class="select-default"
                           :value="option['@id']"
                           :label="option.name"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
        <b-col>
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.firm.list.filters.state') }}:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="filters.state"
                :options="radioOptions"
                buttons
                button-variant="outline-primary"
                name="radios-btn-default"
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import debounce from 'v-debounce'
import getId from '@/utils/getIdFromLink'
import addParamsToQuery from '@/utils/addParamsToQuery'
import { mapActions, mapGetters } from 'vuex'
import { MultiSelect } from 'vue-search-select'
import ApiService from '@/utils/ApiService'

export default {
  name: 'ItemsFiltering',
  components: { MultiSelect },
  data () {
    return {
      itemTagOptions: [],
      delay: 500,
      radioOptions: [
        { value: 1, text: this.$t('buttons.no') },
        { value: 0, text: this.$t('buttons.yes') }
      ],
      filters: {
        name: '',
        category: '',
        measure: '',
        'itemTags.tag': [],
        state: 1
      },
      tagsFilter: [],
      loading: false
    }
  },

  directives: {
    debounce
  },

  watch: {
    filters: {
      deep: true,
      handler () {
        this.filter()
      }
    }
  },

  created () {
    this.fetchItemTagOptions()
    this.getItemTypes()
    this.getItemBrands()
    this.getMeasures()
    this.getCategories()
    this.getVatRates()
  },

  computed: {
    ...mapGetters({
      itemTypes: 'lists/list/itemTypesItems',
      itemBrands: 'lists/list/itemBrandsItems',
      categories: 'lists/list/itemCategoriesItems',
      measures: 'lists/list/measuresItems',
      vatRates: 'lists/list/vatRatesItems'
    }),
    vatRate () {
      if (!this.item.vatRate) return 0
      else {
        return this.vatRates.find(entry => {
          return entry['@id'] === this.item.vatRate
        }).value
      }
    }
  },

  methods: {
    ...mapActions({
      getPage: 'exsbitem/list/getItems',
      getVatRates: 'lists/list/getVatRates',
      getItemTypes: 'lists/list/getItemTypes',
      getItemBrands: 'lists/list/getItemBrands',
      getCategories: 'lists/list/getItemCategories',
      getMeasures: 'lists/list/getMeasures'
    }),

    filter () {
      let link = addParamsToQuery('e_x_s_b_items', this.filters)
      this.getPage(link)
    },

    async fetchItemCategoryOptions () {
      let baseParams = { pagination: false }
      const response = await new ApiService('e_x_c_m_item_categories', baseParams).getResults()
      this.itemCategoryOptions = response.items.map(tag => {
        return {
          value: tag['@id'],
          text: tag.tag
        }
      })
    },
    async fetchItemTagOptions () {
      let baseParams = { pagination: false, tagType: 5 }
      const response = await new ApiService('e_x_c_m_tags', baseParams).getResults()
      this.itemTagOptions = response.items.map(tag => {
        return {
          value: tag['@id'],
          text: tag.tag
        }
      })
    },
    onSelectTags (items, lastSelectItem) {
      this.filters['itemTags.tag'] = items.map(item => {
        return item.value
      })
      this.tagsFilter = items
      this.lastSelectTag = lastSelectItem
    },
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
